module.exports = __webpack_public_path__ + "img/excel.758151d2.svg";